import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=9104eb24&lang=less&scoped=true"

import exportComponent from "/Users/beiyu/Documents/web/森瑶/web/senyao-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9104eb24"]])

export default __exports__